'use client';
import { Icon } from '@chakra-ui/react';
import React, { createContext, useContext } from 'react';
import { CheckCircle, Circle } from 'react-feather';
import { Flex } from '../flex';
import { Card } from '../card';
const SelectCardContext = /*#__PURE__*/ createContext({
    isChecked: false
});
export const Root = (props)=>{
    const { children , isChecked , ...cardProps } = props;
    const boxShadow = isChecked ? 'inset var(--chakra-colors-stroke-interactive) 0px 0px 0px 4px' : '0px 0px 4px rgba(0, 0, 0, 0.08)';
    return /*#__PURE__*/ React.createElement(Card, {
        border: "2px solid rgba(0,0,0,0.08)",
        boxShadow: boxShadow,
        p: 2,
        // Set shadow style to beat .js-focus-visible's specificity in Safari
        style: {
            boxShadow
        },
        tabIndex: 0,
        w: [
            'full',
            null,
            '328px'
        ],
        ...cardProps
    }, /*#__PURE__*/ React.createElement(SelectCardContext.Provider, {
        value: {
            isChecked
        }
    }, children));
};
export const Header = (props)=>{
    const { children , ...flexProps } = props;
    const { isChecked  } = useContext(SelectCardContext);
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        gap: 1.5,
        ...flexProps
    }, children, /*#__PURE__*/ React.createElement(Icon, {
        as: isChecked ? CheckCircle : Circle,
        boxSize: "24px",
        color: isChecked ? 'stroke.interactive' : 'stroke.medium',
        ml: "auto"
    }));
};
export const Body = ({ children  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, children);
export const SelectCard = {
    Body,
    Header,
    Root
};

//# sourceMappingURL=select-card.js.map